import styled from 'styled-components'

export const Container = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr;

	@media(max-width: 900px) {
		grid-template-columns: 1fr 1fr;
	}

	@media(max-width: 600px) {
		display: flex;
		flex-direction: column;
	}
`
